import { createSlice } from '@reduxjs/toolkit';

export const TypeAccountBankSlice = createSlice({
  name: 'type_account_bank',
  initialState: {
    type_account_bank_list: [],
    type_account_bank_list_select: [],
  },
  reducers: {
    setTypeAccountBankRedux: (state, { payload }) => {
      state.type_account_bank_list = payload;
    },
    setTypeAccountBankSelectRedux: (state, { payload }) => {
      state.type_account_bank_list_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTypeAccountBankRedux, setTypeAccountBankSelectRedux } =
  TypeAccountBankSlice.actions;
